import React from "react";
import { motion } from "framer-motion";
import { aboutData } from "../data/about";
import styles from "../styles/About.module.css";

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    },
  };

  return (
    <section className={styles.about} id="about">
      <div className={styles.about__container}>
        <motion.div
          className={styles.about__content}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {/* Text Column */}
          <div className={styles.about__text_col}>
            <motion.h2
              className={styles.about__heading}
              variants={itemVariants}
            >
              {aboutData.heading}
            </motion.h2>

            <motion.div
              className={styles.about__description}
              variants={itemVariants}
            >
              {aboutData.description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </motion.div>

            <motion.div
              className={styles.about__highlights}
              variants={itemVariants}
            >
              {aboutData.highlights.map((item, index) => (
                <span key={index} className={styles.about__highlight}>
                  <span className={styles.about__icon}>{item.icon}</span>
                  {item.label}
                </span>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
